import { useQuery } from '@apollo/client';
import { GET_TEAM_DETAILS } from './query';
export function useGetTeamDetails(id) {
    const { data, loading, error } = useQuery(GET_TEAM_DETAILS, {
        variables: { id },
    });
    const team = data === null || data === void 0 ? void 0 : data.team;
    return { team, loading, error };
}
